<template>
    <SelectDropDown
            :id="id"
            :name="name"
            :label="label"
            @selection-change="countrySelected"
            :options="companies"
            :defaultSelected="defaultSelected ? {id: defaultSelected.iso} : companies[0]"
    />
</template>

<script>
    import SelectDropDown from "@/shared/components/form/SelectDropDown";
    import sharedService from "@/services/shared.service";

    export default {
        name: "CompanyDropdown",
        components: {SelectDropDown},
        props: {
            id: String,
            name: String,
            label: String,
            defaultSelected: Object
        },
        created() {
            sharedService.fetchCompanies()
                .then(({data}) => {
                    this.companies.push({
                        id: 'none',
                        name: '(всички)'
                    });
                    data.forEach(country => this.companies.push(country));
                });
        },
        data() {
            return {
                companies: []
            }
        },
        methods: {
            countrySelected(value) {
                this.$emit('selection-change', {
                    id: value.dropDownId,
                    isDropdown: true,
                    name: value.name,
                    label: value.label,
                    currentValueId: value.currentValue ? value.currentValue.id === 'none' ? '' : value.currentValue.id : '',
                    currentValue: value.currentValue ? value.currentValue.id === 'none' ? '' : value.currentValue.name : '',
                    oldValue: value.oldValue
                });
            }
        }
    }
</script>

<style scoped>

</style>
